import { render, staticRenderFns } from "./CustomerHeader.vue?vue&type=template&id=f281a754"
import script from "./CustomerHeader.vue?vue&type=script&lang=js"
export * from "./CustomerHeader.vue?vue&type=script&lang=js"
import style0 from "./CustomerHeader.vue?vue&type=style&index=0&id=f281a754&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports